import {
    AccountBalance,
    BadgeOutlined,
    CardGiftcardOutlined, CarRentalOutlined,
    DashboardOutlined,
    LogoutRounded,
    MonetizationOnOutlined,
    PersonOutline,
    SavingsOutlined,
    SwapHorizontalCircleOutlined
} from "@mui/icons-material";
import DriverIcon from "../Icons/DriverIcon";
import TripIcon from "../Icons/TripIcon";

const index = [
    {
        title: "Tableau de Bord",
        Icon: DashboardOutlined,
        path: "/dashboard",
    },
    {
        title: "Utilisateurs",
        Icon: PersonOutline,
        path: "/dashboard/users",
    },
    {
        title: "Courses",
        Icon: TripIcon,
        path: "/dashboard/trips",
    }, {
        title: "Conducteurs",
        Icon: DriverIcon,
        path: "/dashboard/drivers",
    },

    {
        title: "Roles",
        Icon: BadgeOutlined,
        path: "/dashboard/roles",
    }
]

export default index
